import axe from '../../services/axios-client/axiosClient';
import managementAxe from '../../services/axios-client/managementServisAxeClient';
import caller from './insuranceRequestsSlice';
import quotationsAxe from '../../services/axios-client/quotationsAxeClient';
import {
  confirmAlert, generalAlertError, generalAlertSuccessToast,
  warningAlert,
} from '../../common/utils/alerts';

const serverError = 'Si è verificato un problema con il server';

export const listInsuranceRequests = async (page, search) => {
  caller.listInsuranceRequestsPending();
  try {
    const res = await managementAxe.get(
      '/broker/quotes/insurance-requests',
      {
        params: {
          ...search,
          page,
        },
      },
    );

    if (res.status !== 200) {
      caller.listInsuranceRequestsReject('Errore Interno');
      return;
    }
    caller.listInsuranceRequestsSuccess(res.data);
  } catch (error) {
    caller.listInsuranceRequestsReject('Errore Interno');
  }
};

export const resetListInsuranceRequests = () => {
  caller.insuranceRequestsReset();
};

export const listFastQuotes = async (page, search) => {
  caller.listFastQuotesPending();
  try {
    const res = await managementAxe.get(
      '/broker/quotes/fast-quotes',
      {
        params: {
          ...search,
          page,
        },
      },
    );

    if (res.status !== 200) {
      caller.listFastQuotesReject('Errore Interno');
      return;
    }
    caller.listFastQuotesSuccess(res.data);
  } catch (error) {
    caller.listFastQuotesReject('Errore Interno');
  }
};

export const resetListFastQuotes = () => {
  caller.fastQuotesReset();
};

export const getMetlifeQuotesData = async (requestToken) => {
  const { data: res } = await quotationsAxe.get(
    `/results/quotes/infortuni/${requestToken}`,
  );

  caller.metlifeQuotesDataUpdated({
    loading: false,
    customer: {
      name: res.data.customer.name,
      surname: res.data.customer.surname,
      gender: res.data.customer.gender,
      fiscal_code: res.data.customer.fiscal_code,
      phone: res.data.customer.phone,
      email: res.data.customer.email,
      date_of_birth: res.data.customer.date_of_birth,
      country_of_birth_code: res.data.customer.country_of_birth_code,
      province_of_birth_code: res.data.customer.province_of_birth_code,
      commune_of_birth_code: res.data.customer.commune_of_birth_code,
      born_abroad: res.data.customer.born_abroad,
      residence_province_code: res.data.customer.residence_province_code,
      residence_commune_code: res.data.customer.residence_commune_code,
      postal_code: res.data.customer.postal_code,
      address: res.data.customer.address,
      house_number: res.data.customer.house_number,
      civil_status_id: res.data.customer.civil_status_id,
      education_level_id: res.data.customer.education_level_id,
      profession_id: res.data.customer.profession_id,
      province: res.data.customer.province,
    },
    quote: {
      request_id: res.data.quote.request_id,
      pack_type: res.data.quote.infortuni.pack_type,
      company: res.data.quote.infortuni.company,
      plan: res.data.quote.infortuni.plan,
      name: res.data.quote.name,
      dc: res.data.quote.decesso,
      ip: res.data.quote.invalidita_permanente,
      diaria_ricovero: res.data.quote.diaria_ricovero,
      diaria_gesso: res.data.quote.diaria_gesso,
      premio_annuo: res.data.quote.premio_annuo,
      ulc: res.data.quote.ulc,
      ulc_premio_aggiuntivo:
        res.data.quote.ulc !== null ? res.data.quote.ulc_premio_aggiuntivo : 0,
      rsm: res.data.quote.rsm,
      rsm_premio_aggiuntivo:
        res.data.quote.rsm !== null ? res.data.quote.rsm_premio_aggiuntivo : 0,
      is_aquista: res.data.quote.is_aquista,
    },
    saved: res.data.quote.is_saved === 1,
    quoteId: res.data.quote.quotation_id,
    insuranceRequest: res.data.insurance_request,
  });
};

export const saveInfortuniQuotation = async (quotationId) => {
  caller.metlifeQuotesDataUpdated({
    isSaving: true,
  });

  await axe.post('/quote-save', {
    quotation_id: quotationId,
  });

  caller.metlifeQuotesDataUpdated({
    isSaving: false,
    saved: true,
  });
};

export const updateInfortuniExtensions = (value) => {
  caller.infortuniQuotesUpdateExtensions(value);
};

export const addInfortuniExtension = async (request_id, extensions) => {
  const data = {
    ulc: '',
    rsm: '',
    request_id,
  };

  if (extensions.includes('ustioni')) {
    data.ulc = 1;
  } else data.ulc = 0;
  if (extensions.includes('rimborso')) {
    data.rsm = 1;
  } else data.rsm = 0;

  caller.metlifeQuotesDataUpdated({
    loading: true,
  });

  const { data: res } = await quotationsAxe.put(
    '/guarantees/infortuni/metlife/update-quote',
    data,
  );

  caller.metlifeQuotesDataUpdated({
    quote: {
      request_id: res.data.request_id,
      pack_type: res.data.pack_type,
      company: res.data.company,
      plan: res.data.plan,
      name: res.data.name,
      dc: res.data.decesso,
      ip: res.data.invalidita_permanente,
      diaria_ricovero: res.data.diaria_ricovero,
      diaria_gesso: res.data.diaria_gesso,
      premio_annuo: res.data.premio_annuo,
      ulc: res.data.ulc,
      ulc_premio_aggiuntivo:
        res.data.ulc !== null ? res.data.ulc_premio_aggiuntivo : 0,
      rsm: res.data.rsm,
      rsm_premio_aggiuntivo:
        res.data.rsm !== null ? res.data.rsm_premio_aggiuntivo : 0,
    },
    loading: false,
  });
};

export const removeInfortuniExtension = async (quote, value) => {
  const data = {
    ulc: quote.ulc !== null ? 1 : 0,
    rsm: quote.rsm !== null ? 1 : 0,
    request_id: quote.request_id,
  };

  if (value === 'ustioni') {
    data.ulc = 0;
  }
  if (value === 'rimborso') {
    data.rsm = 0;
  }

  caller.metlifeQuotesDataUpdated({
    loading: true,
  });

  const { data: res } = await quotationsAxe.post(
    '/infortuni/metlife/update-quote',
    data,
  );

  caller.metlifeQuotesDataUpdated({
    quote: {
      request_id: res.data.request_id,
      pack_type: res.data.pack_type,
      company: res.data.company,
      plan: res.data.plan,
      name: res.data.name,
      dc: res.data.decesso,
      ip: res.data.invalidita_permanente,
      diaria_ricovero: res.data.diaria_ricovero,
      diaria_gesso: res.data.diaria_gesso,
      premio_annuo: res.data.premio_annuo,
      ulc: res.data.ulc,
      ulc_premio_aggiuntivo:
        res.data.ulc !== null ? res.data.ulc_premio_aggiuntivo : 0,
      rsm: res.data.rsm,
      rsm_premio_aggiuntivo:
        res.data.rsm !== null ? res.data.rsm_premio_aggiuntivo : 0,
    },
    loading: false,
  });
};

export const resetInfortuniQuotes = () => {
  caller.infortuniQuotesReset();
};

export const toggleCoveragesAction = (coverageId) => {
  caller.autoQuotesToggleCoverages(coverageId);
};

export const toggleMotoCoveragesAction = (coverageId) => {
  caller.motoQuotesToggleCoverages(coverageId);
};

export const updateGuaranteesAutoAction = async (
  requestToken,
  coverages,
  quoteId,
) => {
  if (quoteId !== undefined || quoteId !== null) {
    await quotationsAxe.post(
      `/guarantees/vehicle/${requestToken}/update-guarantees`,
      {
        coverages,
      },
      {
        params: {
          quoteId,
        },
      },
    );
  } else {
    await quotationsAxe.post(
      `/guarantees/vehicle/${requestToken}/update-guarantees`,
      {
        coverages,
      },
    );
  }

  const res = await quotationsAxe.get(
    `/results/quotes/vehicle/${requestToken}`,
  );
  if (res.status === 200) {
    caller.autoQuotesRequestInfoUpdated(res.data.data);
  }
};

export const updateGuaranteesMotoAction = async (
  requestToken,
  coverages,
  quoteId,
) => {
  if (quoteId !== undefined || quoteId !== null) {
    await quotationsAxe.post(
      `/guarantees/moto/${requestToken}/update-guarantees`,
      {
        coverages,
      },
      {
        params: {
          quoteId,
        },
      },
    );
  } else {
    await quotationsAxe.post(
      `/guarantees/moto/${requestToken}/update-guarantees`,
      {
        coverages,
      },
    );
  }

  const res = await quotationsAxe.get(
    `/results/quotes/moto/${requestToken}`,
  );
  if (res.status === 200) {
    caller.motoQuotesRequestInfoUpdated(res.data.data);
  }
};

// loadAutoQuotes and silentLoadAutoQuotes both refresh the same auto_quotes
// slice and are fired from multiple places (polling intervals, manual
// refreshes) that can overlap. Since responses can arrive out of order, each
// call is tagged with an increasing id and a response is only applied if no
// newer call has been issued since — otherwise a slower, older response
// could overwrite state a more recent request already updated correctly.
let latestAutoQuotesRequestId = 0;

export const loadAutoQuotes = async (requestToken) => {
  latestAutoQuotesRequestId += 1;
  const requestId = latestAutoQuotesRequestId;
  const res = await quotationsAxe.get(
    `/results/quotes/vehicle/${requestToken}`,
  );

  if (requestId !== latestAutoQuotesRequestId) return;

  if (res.status !== 200) {
    caller.autoQuotesRequestInfoRejected(serverError);
  }

  if (res.status === 200) {
    if (res.data.data.quotations[0].coverages === '') {
      caller.autoQuotesCoveragesSet([]);
    } else {
      caller.autoQuotesCoveragesSet(
        res.data.data.quotations[0].coverages.split(','),
      );
    }

    caller.autoQuotesRequestInfoUpdated(res.data.data);
  }
};

export const silentLoadAutoQuotes = async (requestToken) => {
  latestAutoQuotesRequestId += 1;
  const requestId = latestAutoQuotesRequestId;
  const res = await quotationsAxe.get(
    `/results/quotes/vehicle/${requestToken}`,
  );

  if (requestId !== latestAutoQuotesRequestId) return;

  if (res.status !== 200) {
    caller.autoQuotesRequestInfoSilentRejected(serverError);
  }

  if (res.status === 200) {
    if (res.data.data.quotations[0].coverages === '') {
      caller.autoQuotesCoveragesSet([]);
    } else {
      caller.autoQuotesCoveragesSet(
        res.data.data.quotations[0].coverages.split(','),
      );
    }

    caller.autoQuotesRequestInfoSilentUpdated(res.data.data);
  }
};

export const addQuoteAutoToCart = async (quoteId, callback, modifyData, closeButton = null) => {
  caller.autoQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.autoQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.data?.data?.code === 'not_nobis_furto') {
      const error_message = response?.data?.data?.message;
      generalAlertError(error_message || 'La quotazione non e stata aggiunta! Riprova.');
      caller.autoQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }

    if (response.status !== 200) {
      const error_message = response?.data?.error?.message;

      generalAlertError(error_message || 'La quotazione non e stata aggiunta! Riprova.');
      caller.autoQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.autoQuotesDataUpdated({
      addingQuote: false,
    });

    if (closeButton !== null) {
      closeButton();
    }
    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.autoQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeQuoteAutoFromCart = async (quoteId, callback, modifyData) => {
  caller.autoQuotesDataUpdated({
    loading: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.autoQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.autoQuotesDataUpdated({
        loading: false,
      });
      return;
    }
    caller.autoQuotesDataUpdated({
      loading: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.autoQuotesDataUpdated({
      loading: false,
    });
  }
};

export const loadMotoQuotes = async (requestToken) => {
  const res = await quotationsAxe.get(
    `/results/quotes/moto/${requestToken}`,
  );

  if (res.status !== 200) {
    caller.motoQuotesRequestInfoRejected(serverError);
    return;
  }

  if (res.status === 200) {
    if (res.data.data.quotations[0].coverages === '') {
      caller.motoQuotesCoveragesSet([]);
    } else {
      caller.motoQuotesCoveragesSet(
        res.data.data.quotations[0].coverages.split(','),
      );
    }

    caller.motoQuotesRequestInfoUpdated(res.data.data);
  }
};

export const silentLoadMotoQuotes = async (requestToken) => {
  const res = await quotationsAxe.get(
    `/results/quotes/moto/${requestToken}`,
  );

  if (res.status !== 200) {
    caller.motoQuotesRequestInfoSilentRejected(serverError);
    return;
  }

  if (res.status === 200) {
    if (res.data.data.quotations[0].coverages === '') {
      caller.motoQuotesCoveragesSet([]);
    } else {
      caller.motoQuotesCoveragesSet(
        res.data.data.quotations[0].coverages.split(','),
      );
    }

    caller.motoQuotesRequestInfoSilentUpdated(res.data.data);
  }
};

export const addQuoteMotoToCart = async (quoteId, callback, modifyData) => {
  caller.motoQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      const dismissButton = document.getElementById('buttonClose');

      // Trigger a click event on the button
      if (dismissButton) {
        dismissButton.click();
      }
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.motoQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.motoQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.motoQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    const dismissButton = document.getElementById('buttonClose');

    // Trigger a click event on the button
    if (dismissButton) {
      dismissButton.click();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.motoQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeQuoteMotoFromCart = async (quoteId, callback, modifyData) => {
  caller.motoQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.motoQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.motoQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.motoQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.motoQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const updateAutoQuotesData = (requestInfo, sortBy, preventivas_quotes, quotes, quoteTypes) => {
  const { quotations, failed_quotations } = requestInfo;
  let companyIds = [];
  const sortedQuotes = [...quotations];
  const preventivasQuotesSorted = [...preventivas_quotes];
  let toSortQuotes = { ...quotes };
  quotations.forEach((quote) => {
    companyIds.push(quote.company_id);
  });
  failed_quotations.forEach((quote) => {
    companyIds.push(quote.company_id);
  });

  companyIds = companyIds.filter((v, i, a) => a.indexOf(v) === i);

  const toUpdate = {};

  if (quotes === null) {
    toUpdate.quotations = null;
  }
  if (quotations.length === 0) {
    toUpdate.quotes = null;
    toUpdate.noQuotes = true;
  } else {
    if (sortBy === 'amount') {
      for (let x = 0; x < quoteTypes.length; x++) {
        const item = quoteTypes[x];
        let arr = [];
        if (item.id === 'res_civile' && toSortQuotes[item.id] && toSortQuotes[item.id] !== undefined) {
          arr = [...toSortQuotes[item.id]];
          arr.sort((a, b) => a.amount - b.amount);
          toSortQuotes = {
            [item.id]: arr,
          };
        }
      }
      sortedQuotes.sort((a, b) => a.amount - b.amount);
    } else {
      for (let x = 0; x < quoteTypes.length; x++) {
        const item = quoteTypes[x];
        let arr = [];
        if (item.id === 'res_civile' && toSortQuotes[item.id] && toSortQuotes[item.id] !== undefined) {
          arr = [...toSortQuotes[item.id]];
          arr.sort((a, b) => {
            if (a.company_quality && b.company_quality) {
              return a.company_quality.coefficiente - b.company_quality.coefficiente;
            }
            if (!a.company_quality && b.company_quality) {
              return 1;
            } if (a.company_quality && !b.company_quality) {
              return -1;
            }

            if (a.preventivas_company_quality && b.preventivas_company_quality) {
              return a.preventivas_company_quality.coefficiente - b.preventivas_company_quality.coefficiente;
            }
            if (!a.preventivas_company_quality && b.preventivas_company_quality) {
              return 1;
            } if (a.preventivas_company_quality && !b.preventivas_company_quality) {
              return -1;
            }
            return 0;
          });
          toSortQuotes = {
            [item.id]: arr,
          };
        }
      }

      sortedQuotes.sort((a, b) => {
        if (a.company_quality && b.company_quality) {
          return a.company_quality.coefficiente - b.company_quality.coefficiente;
        }
        if (!a.company_quality && b.company_quality) {
          return 1;
        } if (a.company_quality && !b.company_quality) {
          return -1;
        }

        if (a.preventivas_company_quality && b.preventivas_company_quality) {
          return a.preventivas_company_quality.coefficiente - b.preventivas_company_quality.coefficiente;
        }
        if (!a.preventivas_company_quality && b.preventivas_company_quality) {
          return 1;
        } if (a.preventivas_company_quality && !b.preventivas_company_quality) {
          return -1;
        }
        return 0;
      });
    }
    toUpdate.quotes = sortedQuotes;
    toUpdate.noQuotes = false;
    toUpdate.quotations = { ...quotes, res_civile: toSortQuotes.res_civile };
  }

  if (preventivasQuotesSorted.length === 0) {
    toUpdate.preventivas_quotes = [];
  } else {
    toUpdate.preventivas_quotes = preventivasQuotesSorted;
    if (sortBy === 'amount') {
      preventivasQuotesSorted.sort((a, b) => a.amount - b.amount);
      toUpdate.preventivas_quotes = preventivasQuotesSorted;
    } else {
      preventivasQuotesSorted.sort((a, b) => {
        if (a.preventivas_company_quality && b.preventivas_company_quality) {
          return a.preventivas_company_quality.coefficiente - b.preventivas_company_quality.coefficiente;
        }
        if (!a.preventivas_company_quality && b.preventivas_company_quality) {
          return 1;
        } if (a.preventivas_company_quality && !b.preventivas_company_quality) {
          return -1;
        }
        return 0;
      });

      toUpdate.preventivas_quotes = preventivasQuotesSorted;
    }
  }

  toUpdate.failedQuotes = failed_quotations;

  caller.autoQuotesDataUpdated(toUpdate);

  const activeBrands = [1, 2];

  let clearTimer = false;

  if (companyIds.length === activeBrands.length) {
    clearTimer = true;
  }

  return clearTimer;
};

export const updateSortByAuto = (sortBy) => {
  caller.autoQuotesDataUpdated({
    sortBy,
  });
};
export const updateSortByCommercial = (sortBy) => {
  caller.commercialQuotesDataUpdated({
    sortBy,
  });
};
export const fetchAutoReport = async (requestId) => {
  caller.autoQuotesDataUpdated({
    loadingReport: true,
  });
  try {
    const response = await managementAxe.get(`/report/report_auto/${requestId}`);
    if (response.status !== 200) {
      caller.autoQuotesDataUpdated({
        loadingReport: false,
        error: serverError,
      });
    }

    caller.autoQuotesDataUpdated({
      loadingReport: false,
      report: response.data,
    });
  } catch (error) {
    caller.autoQuotesDataUpdated({
      loadingReport: false,
      error: serverError,
    });
  }
};

export const updateMotoQuotesData = (requestInfo) => {
  const { quotations, failed_quotations } = requestInfo;
  let companyIds = [];

  quotations.forEach((quote) => {
    companyIds.push(quote.company_id);
  });

  failed_quotations.forEach((quote) => {
    companyIds.push(quote.company_id);
  });

  companyIds = companyIds.filter((v, i, a) => a.indexOf(v) === i);

  const toUpdate = {};

  if (quotations.length === 0) {
    toUpdate.quotes = null;
    toUpdate.noQuotes = true;
  } else {
    toUpdate.quotes = quotations;
    toUpdate.noQuotes = false;
  }

  toUpdate.failedQuotes = failed_quotations;

  caller.motoQuotesDataUpdated(toUpdate);

  const activeBrands = [1, 2];

  let clearTimer = false;

  if (companyIds.length === activeBrands.length) {
    clearTimer = true;
  }

  return clearTimer;
};

export const resetAutoQuotes = () => {
  caller.autoQuotesReset();
};

export const resetMotoQuotes = () => {
  caller.motoQuotesReset();
};

export const professionQuotesSaveQuote = async (quoteId) => {
  caller.professionQuotesDataUpdated({
    isSaving: true,
  });
  await axe.post('/quote-save', {
    quotation_id: quoteId,
  });
  caller.professionQuotesDataUpdated({
    isSaving: false,
    saved: true,
  });
};

export const professionQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/profession/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.professionQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.professionQuotesDataUpdated({
    loading: false,
    quoteId: response.data.data.quotations[0].id,
    profession: response.data.data.profession,
    userData: response.data.data,
    extensions: response.data.data.profession.extensions,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.customer,
    quotations: response.data.data.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    failedQuotes: response.data.data.failed_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
  });
};

export const professionQuotesSilentGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/profession/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.professionSilentQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.professionSilentQuotesDataUpdated({
    quoteId: response.data.data.quotations[0].id,
    profession: response.data.data.profession,
    userData: response.data.data,
    extensions: response.data.data.profession.extensions,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.customer,
    quotations: response.data.data.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    failedQuotes: response.data.data.failed_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
  });
};

export const addQuoteToCart = async (quoteId, callback, modifyData) => {
  caller.professionQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      const dismissButton = document.getElementById('buttonClose');

      // Trigger a click event on the button
      if (dismissButton) {
        dismissButton.click();
      }

      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.professionQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.professionQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.professionQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    const dismissButton = document.getElementById('buttonClose');

    // Trigger a click event on the button
    if (dismissButton) {
      dismissButton.click();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.professionQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.professionQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.professionQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.professionQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.professionQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.professionQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const professionAddExtension = async (
  requestToken,
  extensions,
  callback,
) => {
  await quotationsAxe.put(`/guarantees/profession/${requestToken}/update`, {
    extensions: extensions.join(','),
  });
  callback();
};

export const resetProfessionQuotes = () => {
  caller.professionQuotesReset();
};

/**
 * Travel Quotes
 */

export const loadTravelQuotes = async (requestToken) => {
  const res = await quotationsAxe.get(`/results/quotes/travel/${requestToken}`);

  caller.travelQuotesDataUpdated({
    insuranceRequest: res.data.insuranceRequest,
    quotations: res.data.quotations,
    failedQuotations: res.data.failed_quotations,
    customer: res.data.customer,
    quotes: res.data.quotes,
    processingQuote: res.data.processingQuote,
    riskQuotations: res.data.risk_quotations,
    thread: res.data.thread,
    est_provvigioni: res.data.stimaProvvigioni,
    loading: false,
  });
};

export const addQuoteTravelToCart = async (quoteId, callback, modifyData) => {
  caller.travelQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      const dismissButton = document.getElementById('buttonClose');
      // Trigger a click event on the button
      if (dismissButton) {
        dismissButton.click();
      }

      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.travelQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.travelQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.travelQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    const dismissButton = document.getElementById('buttonClose');

    // Trigger a click event on the button
    if (dismissButton) {
      dismissButton.click();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.travelQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeQuoteTravelFromCart = async (quoteId, callback, modifyData, resetCoverages) => {
  caller.travelQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.travelQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.travelQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }

    resetCoverages();
    caller.travelQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.travelQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const resetTravelQuotes = () => {
  caller.travelQuotesReset();
};

export const updateTravelGuarantee = async (
  quoteId,
  coverages,
  requestToken,
) => {
  const res = await quotationsAxe.put(`/guarantees/travel/${quoteId}/update`, {
    coverages,
  });

  if (res.status === 200) {
    loadTravelQuotes(requestToken);
  }
};

/**
 * Commercial Quotes
 */

export const loadCommercialQuotes = async (requestToken) => {
  const res = await quotationsAxe.get(
    `/results/quotes/commercial/${requestToken}`,
  );

  caller.commercialQuotesDataUpdated({
    insuranceRequest: res.data.data,
    processingQuote: res.data.data.processingQuote,
    quotes: res.data.data.quotes,
    quotations: res.data.quotations,
    companyData: res.data.data.commercial_company,
    loading: false,
    failedQuotes: res.data.data.failedQuotes,
    commercial_company_report: res.data.data.commercial_company_report,
    risk_quotations: res.data.data.risk_quotations,
    thread: res.data.data.thread,
    est_provvigioni: res.data.data.stimaProvvigioni,
  });
};

export const resetCommercialQuotes = () => {
  caller.commercialQuotesReset();
};

// ? do we need this ?
// export const updateCommercialGuarantee = async (
//   quoteId,
//   coverages,
// ) => {
//   const res = await quotationsAxe.put(
//     `/guarantees/commercial/${quoteId}/update`,
//     {
//       coverages,
//     },
//   );

//   if (res.status === 200) {
//     console.log('success update commercial guarantee');
//     // todo right action here
//   }
// };

export const addQuoteCommercialToCart = async (quoteId, callback, modifyData, closeButton = null) => {
  caller.commercialQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.commercialQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.commercialQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.commercialQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.commercialQuotesDataUpdated({
      addingQuote: false,
    });
  }
};
export const removeQuoteCommercialFromCart = async (quoteId, callback, modifyData) => {
  caller.commercialQuotesDataUpdated({
    loading: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.commercialQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.commercialQuotesDataUpdated({
        loading: false,
      });
      return;
    }
    caller.commercialQuotesDataUpdated({
      loading: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.commercialQuotesDataUpdated({
      loading: false,
    });
  }
};

export const updateQuotesData = (requestInfo, sortBy, quotes, quoteTypes) => {
  const { quotations } = requestInfo;
  let companyIds = [];
  const sortedQuotes = [...quotations];
  let toSortQuotes = { ...quotes };

  quotations.forEach((quote) => {
    companyIds.push(quote.company_id);
  });

  companyIds = companyIds.filter((v, i, a) => a.indexOf(v) === i);

  const toUpdate = {};

  if (quotes === null) {
    toUpdate.quotations = null;
  }
  if (quotations.length === 0) {
    toUpdate.quotes = null;
    toUpdate.noQuotes = true;
  } else {
    if (sortBy === 'amount') {
      for (let x = 0; x < quoteTypes.length; x++) {
        const item = quoteTypes[x];
        let arr = [];
        if (item.id === 'res_civile' && toSortQuotes[item.id] && toSortQuotes[item.id] !== undefined) {
          arr = [...toSortQuotes[item.id]];
          arr.sort((a, b) => a.amount - b.amount);
          toSortQuotes = {
            [item.id]: arr,
          };
        }
      }
      sortedQuotes.sort((a, b) => a.amount - b.amount);
    }

    toUpdate.quotations = sortedQuotes;
    toUpdate.noQuotes = false;
    toUpdate.quotes = { ...quotes, res_civile: toSortQuotes.res_civile };
  }

  caller.commercialQuotesDataUpdated(toUpdate);

  const activeBrands = [1, 2];

  let clearTimer = false;

  if (companyIds.length === activeBrands.length) {
    clearTimer = true;
  }

  return clearTimer;
};
export const listRenewals = async (page, search) => {
  caller.listRenewalsPending();
  try {
    const searchParams = {
      ...search,
    };
    if (searchParams.search !== '') {
      delete searchParams.date_from;
      delete searchParams.date_to;
    }

    const res = await axe.get('/renewals/list', {
      params: {
        ...searchParams,
        page,
      },
    });

    if (res.status !== 200) {
      caller.listRenewalsReject('Errore Interno');
      return;
    }
    caller.listRenewalsSuccess(res.data.data);
  } catch (error) {
    caller.listRenewalsReject('Errore Interno');
  }
};

export const resetRenewals = () => {
  caller.listRenewalsReset();
};

export const markQuotationForProccessing = async (quotationId, successCallback) => {
  const res = await axe.put(`/quotations/${quotationId}/process/select`);

  if (res.status !== 200) {
    generalAlertError('Errore interno');
    return;
  }

  generalAlertSuccessToast('Preventivo Salvato');
  successCallback();
};

export const tutelaLegaleQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/tutela-legale/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.tutelaLegaleQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.tutelaLegaleQuotesDataUpdated({
    loading: false,
    quoteId: response.data.data.quotations[0].id,
    userData: response.data.data,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.customer,
    quotations: response.data.data.quotes,
    processingQuote: response.data.data.processingQuote,
    tutelaLegaleQuote: response.data.data.tutelaLegaleQuote,
    riskQuotations: response.data.data.risk_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
  });
};

export const resetTutelaLegaleQuotes = () => {
  caller.tutelaLegaleQuotesReset();
};

export const addVehicleAmount = async (requestToken, collectData, value, setVehicleAmount) => {
  caller.addVehicleAmountPending();

  try {
    const res = await axe.post(`/quote/add-extra-risks/${requestToken}`, { value });

    if (res.status === 400 && res?.data?.error === 'vehicle_older_than_10_years') {
      warningAlert('Non è possibile aggiungere la garanzia per veicoli oltre i 10 anni');
      caller.addVehicleAmountSuccess();
      setVehicleAmount({
        furto_incendio: '',
        eventi_naturali: '',
        eventi_socio_politici: '',
      });
      return;
    }

    if (res.status !== 200) {
      caller.addVehicleAmountRejected(serverError);
      setVehicleAmount({
        furto_incendio: '',
        eventi_naturali: '',
        eventi_socio_politici: '',
      });
      return;
    }

    caller.addVehicleAmountSuccess();
    collectData();
  } catch (error) {
    caller.addVehicleAmountRejected('Errore Interno');
  }
};

export const houseQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/house/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.houseQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.houseQuotesDataUpdated({
    loading: false,
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    failedQuotes: response.data.data.quotations.failed_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
  });
};

export const houseQuotesSilentGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/house/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.houseQuotesDataSilentUpdatedRejected(serverError);
    return;
  }

  caller.houseQuotesDataSilentUpdated({
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    failedQuotes: response.data.data.quotations.failed_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
  });
};

export const resetHouseQuotes = () => {
  caller.houseQuotesReset();
};

export const addHouseQuoteToCart = async (quoteId, callback, modifyData, closeButton = null) => {
  caller.houseQuotesDataUpdated({
    addingQuote: true,
  });

  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }

      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.houseQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.houseQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.houseQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.houseQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeHouseQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.houseQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.houseQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.houseQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.houseQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.houseQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const saluteQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/salute/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.saluteQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.saluteQuotesDataUpdated({
    loading: false,
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    toSelect: [],
    quote_id_to_add: null,
    error: null,
  });
};

export const resetSaluteQuotes = () => {
  caller.saluteQuotesReset();
};

export const addSaluteQuoteToCart = async (quoteId, callback, modifyData, closeButton = null, showModal = null, quote_id_to_add = null) => {
  caller.saluteQuotesDataUpdated({
    addingQuote: true,
  });

  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.status === 400 && response.data.data.code === 'to_select') {
      if (closeButton !== null) {
        closeButton();
      }
      showModal(true);
      caller.saluteQuotesDataUpdated({
        loading: false,
        addingQuote: false,
        toSelect: response.data.data.toSelect,
        quote_id_to_add: response.data.data.quote_id_to_add,
      });
      return;
    }

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.saluteQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.saluteQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }

    if (quote_id_to_add !== null) {
      const res = await axe.get(`/quotations/save/${quote_id_to_add}`);

      if (res.data.error === 'insurance_in_process') {
        if (closeButton !== null) {
          closeButton();
        }
        confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
        caller.saluteQuotesDataUpdated({
          addingQuote: false,
          loading: false,
        });
        return;
      }

      if (res.status !== 200) {
        generalAlertError('La quotazione non e stata aggiunta! Riprova.');
        caller.saluteQuotesDataUpdated({
          addingQuote: false,
        });
        return;
      }
      showModal(false);
    }

    caller.saluteQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.saluteQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeSaluteQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.saluteQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.saluteQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.saluteQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.saluteQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.saluteQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

// Ancillari Auto

export const ancillariAutoQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/ancillari-auto/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.ancillariAutoQuotesDataUpdated(serverError);
    return;
  }

  caller.ancillariAutoQuotesDataUpdated({
    loading: false,
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    vehicle: response.data.data.vehicle,
    failedQuotes: response.data.data.quotations.failed_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
  });
};

export const silentLoadAncillariQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/ancillari-auto/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.ancillariAutoQuotesDataSilentRejected(serverError);
    return;
  }

  caller.ancillariAutoQuotesDataSilentUpdated({
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    vehicle: response.data.data.vehicle,
    failedQuotes: response.data.data.quotations.failed_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
  });
};

export const resetAncillariAutoQuotes = () => {
  caller.ancillariAutoQuotesReset();
};

export const addAncillariAutoQuoteToCart = async (quoteId, callback, modifyData, closeButton = null) => {
  caller.ancillariAutoQuotesDataUpdated({
    addingQuote: true,
  });

  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }

      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.ancillariAutoQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      if (response.status === 400 && response.data.data.error === 'can_not_add_cristalli') {
        generalAlertError(response.data.data.message);
      } else if (response.status === 400 && response.data.data.error === 'can_not_add_collisione') {
        generalAlertError(response.data.data.message);
      } else {
        generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      }

      caller.ancillariAutoQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.ancillariAutoQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.ancillariAutoQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeAncillariAutoQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.ancillariAutoQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.ancillariAutoQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.ancillariAutoQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.ancillariAutoQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.ancillariAutoQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const sanitariaStranieriQuotesGetQuotes = async (requestToken) => {
  caller.sanitariaStranieriQuotesDataUpdated({
    loading: true,
  });
  const response = await quotationsAxe.get(
    `/results/quotes/sanitaria-stranieri/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.sanitariaStranieriQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.sanitariaStranieriQuotesDataUpdated({
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    failedQuotes: response.data.data.quotations.failed_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
    loading: false,
  });
};

export const sanitariaStranieriQuotesSilentGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/sanitaria-stranieri/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.sanitariaStranieriQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.sanitariaStranieriQuotesDataUpdated({
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    failedQuotes: response.data.data.quotations.failed_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
    loading: false,
  });
};

export const resetSanitariaStranieriQuotes = () => {
  caller.sanitariaStranieriQuotesReset();
};

export const addSanitariaStranieriQuoteToCart = async (quoteId, callback, modifyData, closeButton = null) => {
  caller.sanitariaStranieriQuotesDataUpdated({
    addingQuote: true,
  });

  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }

      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.sanitariaStranieriQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.sanitariaStranieriQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.sanitariaStranieriQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.sanitariaStranieriQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeSanitariaStranieriQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.sanitariaStranieriQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.sanitariaStranieriQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.sanitariaStranieriQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.sanitariaStranieriQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.sanitariaStranieriQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const professioniSanitaQuotesGetQuotes = async (requestToken) => {
  caller.professioneStranieriQuotesDataUpdated({
    loading: true,
  });
  const response = await quotationsAxe.get(
    `/results/quotes/professione-sanita/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.professioneStranieriQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.professioneStranieriQuotesDataUpdated({
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    failedQuotes: response.data.data.quotations.failed_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
    loading: false,
  });
};

export const professioniSanitaSilentQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/professione-sanita/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.professioneStranieriQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.professioneStranieriQuotesDataUpdated({
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    failedQuotes: response.data.data.quotations.failed_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
    loading: false,
  });
};

export const resetProfessioniSanitaQuotes = () => {
  caller.professioneStranieriQuotesReset();
};

export const addProfessioneSanitariaQuoteToCart = async (quoteId, callback, modifyData, closeButton = null) => {
  caller.professioneStranieriQuotesDataUpdated({
    addingQuote: true,
  });

  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }

      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.professioneStranieriQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.professioneStranieriQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.professioneStranieriQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.professioneStranieriQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeProfessioniSanitaQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.professioneStranieriQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.professioneStranieriQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.professioneStranieriQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.professioneStranieriQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.professioneStranieriQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const publicEmploymentQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/public-employment/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.publicEmploymentQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.publicEmploymentQuotesDataUpdated({
    loading: false,
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    organization_data: response.data.data.organization_data,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    toSelect: [],
    quote_id_to_add: null,
    error: null,
  });
};

export const resetPublicEmploymentQuotes = () => {
  caller.publicEmploymentQuotesReset();
};

export const addPublicEmploymentQuoteToCart = async (quoteId, callback, modifyData, closeButton = null, showModal = null, quote_id_to_add = null) => {
  caller.publicEmploymentQuotesDataUpdated({
    addingQuote: true,
  });

  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.status === 400 && response.data.data.code === 'to_select') {
      if (closeButton !== null) {
        closeButton();
      }
      showModal(true);
      caller.publicEmploymentQuotesDataUpdated({
        loading: false,
        addingQuote: false,
        toSelect: response.data.data.toSelect,
        quote_id_to_add: response.data.data.quote_id_to_add,
      });
      return;
    }

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.publicEmploymentQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.publicEmploymentQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }

    if (quote_id_to_add !== null) {
      const res = await axe.get(`/quotations/save/${quote_id_to_add}`);

      if (res.data.error === 'insurance_in_process') {
        if (closeButton !== null) {
          closeButton();
        }
        confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
        caller.publicEmploymentQuotesDataUpdated({
          addingQuote: false,
          loading: false,
        });
        return;
      }

      if (res.status !== 200) {
        generalAlertError('La quotazione non e stata aggiunta! Riprova.');
        caller.publicEmploymentQuotesDataUpdated({
          addingQuote: false,
        });
        return;
      }
      showModal(false);
    }

    caller.publicEmploymentQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.publicEmploymentQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removePublicEmploymentQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.publicEmploymentQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Avviso!');
      caller.publicEmploymentQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.publicEmploymentQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.publicEmploymentQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.publicEmploymentQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const malattiaQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/malattia/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.malattiaQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.malattiaQuotesDataUpdated({
    loading: false,
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    toSelect: [],
    quote_id_to_add: null,
    error: null,
  });
};

export const resetMalattiaQuotes = () => {
  caller.malattiaQuotesReset();
};

export const addMalattiaQuoteToCart = async (quoteId, callback, modifyData, closeButton = null, showModal = null, quote_id_to_add = null) => {
  caller.malattiaQuotesDataUpdated({
    addingQuote: true,
  });

  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.status === 400 && response.data.data.code === 'to_select') {
      if (closeButton !== null) {
        closeButton();
      }
      showModal(true);
      caller.malattiaQuotesDataUpdated({
        loading: false,
        addingQuote: false,
        toSelect: response.data.data.toSelect,
        quote_id_to_add: response.data.data.quote_id_to_add,
      });
      return;
    }

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
      caller.malattiaQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.malattiaQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }

    if (quote_id_to_add !== null) {
      const res = await axe.get(`/quotations/save/${quote_id_to_add}`);

      if (res.data.error === 'insurance_in_process') {
        if (closeButton !== null) {
          closeButton();
        }
        confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
        caller.malattiaQuotesDataUpdated({
          addingQuote: false,
          loading: false,
        });
        return;
      }

      if (res.status !== 200) {
        generalAlertError('La quotazione non e stata aggiunta! Riprova.');
        caller.malattiaQuotesDataUpdated({
          addingQuote: false,
        });
        return;
      }
      showModal(false);
    }

    caller.malattiaQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.malattiaQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeMalattiaQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.malattiaQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
      caller.malattiaQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.malattiaQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.malattiaQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.malattiaQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

// ** Infortunio

export const infortunioQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/infortunio/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.infortunioQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.infortunioQuotesDataUpdated({
    loading: false,
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    toSelect: [],
    quote_id_to_add: null,
    error: null,
  });
};

export const resetInfortunioQuotes = () => {
  caller.infortunioQuotesReset();
};

export const addInfortunioQuoteToCart = async (quoteId, callback, modifyData, closeButton = null, showModal = null, quote_id_to_add = null) => {
  caller.infortunioQuotesDataUpdated({
    addingQuote: true,
  });

  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.status === 400 && response.data.data.code === 'to_select') {
      if (closeButton !== null) {
        closeButton();
      }
      showModal(true);
      caller.infortunioQuotesDataUpdated({
        loading: false,
        addingQuote: false,
        toSelect: response.data.data.toSelect,
        quote_id_to_add: response.data.data.quote_id_to_add,
      });
      return;
    }

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
      caller.infortunioQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.infortunioQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }

    if (quote_id_to_add !== null) {
      const res = await axe.get(`/quotations/save/${quote_id_to_add}`);

      if (res.data.error === 'insurance_in_process') {
        if (closeButton !== null) {
          closeButton();
        }
        confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
        caller.infortunioQuotesDataUpdated({
          addingQuote: false,
          loading: false,
        });
        return;
      }

      if (res.status !== 200) {
        generalAlertError('La quotazione non e stata aggiunta! Riprova.');
        caller.infortunioQuotesDataUpdated({
          addingQuote: false,
        });
        return;
      }
      showModal(false);
    }

    caller.infortunioQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.infortunioQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeInfortunioQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.infortunioQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
      caller.infortunioQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.infortunioQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.infortunioQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.infortunioQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

// ** Condominio

export const condominioQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/condominio/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.condominioQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.condominioQuotesDataUpdated({
    loading: false,
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    toSelect: [],
    quote_id_to_add: null,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
  });
};

export const condominioQuotesSilentGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/condominio/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.condominioQuotesDataSilentUpdatedRejected(serverError);
    return;
  }

  caller.condominioQuotesSilentDataUpdated({
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    toSelect: [],
    quote_id_to_add: null,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
  });
};

export const resetCondominioQuotes = () => {
  caller.condominioQuotesReset();
};

export const addCondominioQuoteToCart = async (quoteId, callback, modifyData, closeButton = null, showModal = null, quote_id_to_add = null) => {
  caller.condominioQuotesDataUpdated({
    addingQuote: true,
  });

  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.status === 400 && response.data.data.code === 'to_select') {
      if (closeButton !== null) {
        closeButton();
      }
      showModal(true);
      caller.condominioQuotesDataUpdated({
        loading: false,
        addingQuote: false,
        toSelect: response.data.data.toSelect,
        quote_id_to_add: response.data.data.quote_id_to_add,
      });
      return;
    }

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
      caller.condominioQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.condominioQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }

    if (quote_id_to_add !== null) {
      const res = await axe.get(`/quotations/save/${quote_id_to_add}`);

      if (res.data.error === 'insurance_in_process') {
        if (closeButton !== null) {
          closeButton();
        }
        confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
        caller.condominioQuotesDataUpdated({
          addingQuote: false,
          loading: false,
        });
        return;
      }

      if (res.status !== 200) {
        generalAlertError('La quotazione non e stata aggiunta! Riprova.');
        caller.condominioQuotesDataUpdated({
          addingQuote: false,
        });
        return;
      }
      showModal(false);
    }

    caller.condominioQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.condominioQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeCondominioQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.condominioQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
      caller.condominioQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.condominioQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.condominioQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.condominioQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const addCondominioMassimaleAmount = async (requestToken, collectData, value, setMassimaleAmount, quoteType) => {
  caller.addMassimaleCondominioAmountPending();

  try {
    const res = await axe.post(
      `/quote/add-extra-risks-condominio/${requestToken}`,
      {
        massimale: value,
        quote_type: quoteType,
      },
    );

    // if (res.status === 400 && res?.data?.error === 'vehicle_older_than_10_years') {
    //   warningAlert('Non è possibile aggiungere la garanzia per veicoli oltre i 10 anni');
    //   caller.addMassimaleCondominioAmountSuccess();
    //   setMassimaleCondominioAmount({
    //     furto_incendio: '',
    //     eventi_naturali: '',
    //     eventi_socio_politici: '',
    //   });
    //   return;
    // }

    if (res.status !== 200) {
      caller.addMassimaleCondominioAmountRejected(serverError);
      setMassimaleAmount({
        cristalli_e_vetri: '',
        assistenza: '',
      });
      return;
    }

    caller.addMassimaleCondominioAmountSuccess();
    collectData();
  } catch (error) {
    caller.addMassimaleCondominioAmountRejected('Errore Interno');
  }
};

// ** Rc Famiglia

export const rcFamigliaQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/rc-famiglia/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.rcFamigliaQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.rcFamigliaQuotesDataUpdated({
    loading: false,
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    toSelect: [],
    quote_id_to_add: null,
    thread: response.data.data.thread,
    est_provvigioni: response.data.data.stimaProvvigioni,
    error: null,
  });
};

export const resetRcFamigliaQuotes = () => {
  caller.rcFamigliaQuotesReset();
};

export const addRcFamigliaQuoteToCart = async (quoteId, callback, modifyData, closeButton = null, showModal = null, quote_id_to_add = null) => {
  caller.rcFamigliaQuotesDataUpdated({
    addingQuote: true,
  });

  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.status === 400 && response.data.data.code === 'to_select') {
      if (closeButton !== null) {
        closeButton();
      }
      showModal(true);
      caller.rcFamigliaQuotesDataUpdated({
        loading: false,
        addingQuote: false,
        toSelect: response.data.data.toSelect,
        quote_id_to_add: response.data.data.quote_id_to_add,
      });
      return;
    }

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
      caller.rcFamigliaQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.rcFamigliaQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }

    if (quote_id_to_add !== null) {
      const res = await axe.get(`/quotations/save/${quote_id_to_add}`);

      if (res.data.error === 'insurance_in_process') {
        if (closeButton !== null) {
          closeButton();
        }
        confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
        caller.rcFamigliaQuotesDataUpdated({
          addingQuote: false,
          loading: false,
        });
        return;
      }

      if (res.status !== 200) {
        generalAlertError('La quotazione non e stata aggiunta! Riprova.');
        caller.rcFamigliaQuotesDataUpdated({
          addingQuote: false,
        });
        return;
      }
      showModal(false);
    }

    caller.rcFamigliaQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.rcFamigliaQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeRcFamigliaQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.rcFamigliaQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
      caller.rcFamigliaQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.rcFamigliaQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.rcFamigliaQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.rcFamigliaQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

// ** Monopattini

export const monopattiniQuotesGetQuotes = async (requestToken) => {
  const response = await quotationsAxe.get(
    `/results/quotes/monopattini-elettrici/${requestToken}`,
  );

  if (response.status !== 200) {
    caller.monopattiniQuotesDataUpdatedRejected(serverError);
    return;
  }

  caller.monopattiniQuotesDataUpdated({
    loading: false,
    data: response.data,
    quoteId: response.data.data.quotations.id,
    insuranceRequest: response.data.data.quotations,
    selling_point: response.data.data.selling_point,
    distance_token: response.data.data.distance_token,
    customer: response.data.data.quotations.customer,
    quotations: response.data.data.quotations.quotes,
    processingQuote: response.data.data.processingQuote,
    riskQuotations: response.data.data.risk_quotations,
    toSelect: [],
    quote_id_to_add: null,
    error: null,
  });
};

export const resetMonopattiniQuotes = () => {
  caller.monopattiniQuotesReset();
};

export const addMonopattiniQuoteToCart = async (quoteId, callback, modifyData, closeButton = null, showModal = null, quote_id_to_add = null) => {
  caller.monopattiniQuotesDataUpdated({
    addingQuote: true,
  });

  try {
    const response = await axe.get(`/quotations/save/${quoteId}`);

    if (response.status === 400 && response.data.data.code === 'to_select') {
      if (closeButton !== null) {
        closeButton();
      }
      showModal(true);
      caller.monopattiniQuotesDataUpdated({
        loading: false,
        addingQuote: false,
        toSelect: response.data.data.toSelect,
        quote_id_to_add: response.data.data.quote_id_to_add,
      });
      return;
    }

    if (response.data.error === 'insurance_in_process') {
      if (closeButton !== null) {
        closeButton();
      }
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
      caller.monopattiniQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata aggiunta! Riprova.');
      caller.monopattiniQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }

    if (quote_id_to_add !== null) {
      const res = await axe.get(`/quotations/save/${quote_id_to_add}`);

      if (res.data.error === 'insurance_in_process') {
        if (closeButton !== null) {
          closeButton();
        }
        confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
        caller.monopattiniQuotesDataUpdated({
          addingQuote: false,
          loading: false,
        });
        return;
      }

      if (res.status !== 200) {
        generalAlertError('La quotazione non e stata aggiunta! Riprova.');
        caller.monopattiniQuotesDataUpdated({
          addingQuote: false,
        });
        return;
      }
      showModal(false);
    }

    caller.monopattiniQuotesDataUpdated({
      addingQuote: false,
    });

    callback();

    if (closeButton !== null) {
      closeButton();
    }
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.monopattiniQuotesDataUpdated({
      addingQuote: false,
    });
  }
};

export const removeMonopattiniQuoteFromCart = async (quoteId, callback, modifyData) => {
  caller.monopattiniQuotesDataUpdated({
    addingQuote: true,
  });
  try {
    const response = await axe.get(`/quotations/remove/${quoteId}`);

    if (response.data.error === 'insurance_in_process') {
      confirmAlert('Non è possibile modificare, vuoi che ricalcoliamo?', () => modifyData(), () => { }, 'Aviso!');
      caller.monopattiniQuotesDataUpdated({
        addingQuote: false,
        loading: false,
      });
      return;
    }

    if (response.status !== 200) {
      generalAlertError('La quotazione non e stata rimossa! Riprova.');
      caller.monopattiniQuotesDataUpdated({
        addingQuote: false,
      });
      return;
    }
    caller.monopattiniQuotesDataUpdated({
      addingQuote: false,
    });

    callback();
  } catch (error) {
    generalAlertError('Errore Interno.');
    caller.monopattiniQuotesDataUpdated({
      addingQuote: false,
    });
  }
};
